export const header = {
    columns: [
        {
            text: 'Мотордата Нормы времени',
            fontSize: 10,
        },
        {
            text: 'http://motordata.net/ru',
            fontSize: 10,
            alignment: 'right'
        },
    ]
}